import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import FirearmCompetencyTypeForm from '../../../components/forms/FirearmCompetencyTypeForm';
import { useFirearmCompetencyTypeById, useUpdateFirearmCompetencyType } from '../../../hooks/useFirearmCompetencyTypeApi';
import { useNavigate, useParams } from 'react-router-dom';
import Card from '../../../components/common/Card';
import { FirearmCompetencyTypeDTO } from '../../../services/apiClient';

const FirearmCompetencyTypeEdit: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const { data: entityData, isLoading } = useFirearmCompetencyTypeById(id!);
  const updateFirearmCompetencyType = useUpdateFirearmCompetencyType();
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Firearm Competency Types', href: '/admin/firearmcompetencytypes' },
    { label: 'Edit', href: '#' },
  ];

  const handleSubmit = async (data: any) => {
    try {
      setIsSubmitting(true);
      await updateFirearmCompetencyType.mutateAsync({ id: id!, data });
      navigate('/admin/firearmcompetencytypes');
    } catch (error) {
      console.error('Error updating FirearmCompetencyType:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/firearmcompetencytypes"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Settings.FirearmCompetencyType.Edit'
    >
        {entityData ? (
          <FirearmCompetencyTypeForm
            initialValues={entityData}
            onSubmit={handleSubmit}
            onCancel={() => navigate('/admin/firearmcompetencytypes')}
          />
        ) : (
          <p>Loading...</p>
        )}
    </AdminLayout>
  );
};

export default FirearmCompetencyTypeEdit;